import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export default class AdsRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  getLastAdsSearchParams() {
    throw new Error('[AdsRepository#getLastAdsSearchParams] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getLastAdsSearches() {
    throw new Error('[AdsRepository#getLastAdsSearches] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  saveLastAdsSearch() {
    throw new Error('[AdsRepository#saveLastAdsSearch] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getHomeAds() {
    throw new Error('[AdsRepository#getHomeAds] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getAdsSearchParams() {
    throw new Error('[AdsRepository#getAdsSearchParams] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  reportAd() {
    throw new Error('[AdsRepository#reportAd] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  getInstantOffer() {
    throw new Error('[AdsRepository#getInstantOffer] must be implemented')
  }
}
